import React, { useMemo, useState } from "react";
import TableContainer from "./TableContainer";
import moment from "moment";
import "./PatientNotesTableStyles.css";
import { useSelector } from "react-redux";
import { getFullName, notify } from "../../../../../util/helpers";
import NotesModal from "./NotesModal";
import PatientNotesPDF from "./PatientNotesPDF";

const CTAComponent = ({ callback1, callback2,callback3 ,callback4,data}) => {
  return (
    <td style={{ display: "flex", gap: "8px" }}>
      <button className="cta-button" onClick={callback1}>
        View
      </button>
      <button className="cta-button-alt" onClick={callback2}>
        Export PDF
      </button>
      {data?.diagnosis == "Self Added Note" && <button className="cta-button-alt" onClick={callback3}>
        Delete
      </button>}
      {data?.diagnosis == 'Self Added Note' && <button className="cta-button-alt" onClick={callback4}>
        Edit
      </button>}
    </td>
  );
};



const PatientNotesTable = (props) => {
  const { staffData } = useSelector((state) => state.app);
  const [modalIsOpen, setModalOpen] = useState(false);
  const [data, setData] = useState({});
  const [singleNote, setSingleNote] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: "Date Created",
        accessor: "created",
        sortType: (a, b) => {
          return new Date(b?.values?.created) - new Date(a?.values?.created);
        },
        Cell: ({ cell }) => {
          return (
            <small>
              {cell.value
                ? moment(cell.value).format("MMM DD, YYYY")
                : "Not Available"}
            </small>
          );
        },
      },
      {
        Header: "Date Updated",
        accessor: "modified",
        Cell: ({ cell }) => {
          return (
            <small>
              {cell.value
                ? moment(cell.value).format("MMM DD, YYYY")
                : "Not Available"}
            </small>
          );
        },
      },
      {
        Header: "Created By",
        accessor: "added_by",
        Cell: ({ cell }) => {
          const added_by_staff = staffData.find((staff) => {
            if (staff.id === cell.value) {
              return staff;
            }
          });
          return (
            <small>
              {added_by_staff ? getFullName(added_by_staff) : "Not available"}
            </small>
          );
        },
      },
      {
        Header: "BHI Diagnosis",
        accessor: "diagnosis",
        Cell: ({ cell }) => {
          return <small>{cell.value || "Not Available"}</small>;
        },
      },
      {
        Header: "Notes",
        accessor: "notes",
        Cell: ({ cell }) => {
          return <small>{cell.value || "Not Available"}</small>;
        },
      },
      {
        Header: " ",
        accessor: (d) => d,
        Cell: ({ cell }) => {
          return (
            <CTAComponent
              callback1={() => {
                setModalOpen(true);
                setData(cell.value);
              }}
              callback2={() => {
                setData(cell.value);
                setSingleNote(true);
                props?.setNotesDownloadMode(true);
                // notify("This feature is coming soon!", "info");
              }}
              callback3={() => {
                setData(cell.value);
                props.setNoteBeingEdited(cell.value);
                props.setShowDeleteNoteModal(true);
              }}
              callback4={() => {
                setData(cell.value);
                console.log(data,'data for edit')
                props.setShowEditNoteModal(true);
                props.setNoteBeingEdited(cell.value);
              }}
              data={cell.value}
            />
          );
        },
      },
    ],
    []
  );

  return (
    <>
      <NotesModal
        setIsOpen={setModalOpen}
        modalIsOpen={modalIsOpen}
        data={data}
      />
      <TableContainer
        columns={columns}
        data={props?.data}
        notesFilterValue={props?.notesFilterValue}
        startDate={props.startDate}
        endDate={props.endDate}
      />
      {props?.notesDownloadMode && (
        <>
          <div style={{ height: "100vh" }} />
          <PatientNotesPDF
            startDate={props?.startDate}
            endDate={props?.endDate}
            setNotesDownloadMode={props?.setNotesDownloadMode}
            singleNote={singleNote}
            setSingleNote={setSingleNote}
            singleNoteData={data}
            filteredPatientNotesData={props.data}
          />
        </>
      )}
    </>
  );
};

export default PatientNotesTable;
